/**
 * Update Enhancement Bundle API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../../axiosInstance';
import { EnhancementBundle } from '../types';

interface UpdateBundleResponse {
  bundle: EnhancementBundle;
}

export const updateEnhancementBundle = async (
  id: string,
  bundle: Partial<EnhancementBundle>
): Promise<EnhancementBundle> => {
  const response = await axiosInstance.put<UpdateBundleResponse>(
    `/api/enhancement-bundles/${id}`,
    bundle
  );

  return response.data.bundle;
};
